import { Messages } from './translate';
import { Config } from './config';
import { HttpClient } from '@wix/http-client';

export class DataFetcher {
  private readonly config: Config;
  private readonly editorxHnFVersion: string | undefined;
  private readonly httpClient = new HttpClient();

  constructor(config: Config) {
    this.config = config;
    this.editorxHnFVersion = window.EDITOR_X_HF_VERSION;
  }

  fetchTranslations() {
    return this.httpClient
      .get(`${this.getStaticBaseUrl()}/assets/locales/messages_${this.config.getContentLanguage()}.json`)
      .then((response) => response.data) as Promise<Messages>;
  }

  private getStaticBaseUrl() {
    if (!window.EDITOR_X_HF_DEBUG && this.editorxHnFVersion) {
      return `//static.parastorage.com/services/editorx-header-and-footer/${this.editorxHnFVersion}/`;
    } else {
      return 'http://localhost:3200';
    }
  }
}
